import React from 'react';
import { Container } from 'react-bootstrap';
import '../App.css'; 

const ResponsiveImage = () => {
    return (
      <Container fluid className="p-0 d-flex justify-content-center  align-items-center vh-40 bg-image blue-border">
    
      </Container>
    );
  };
  
  export default ResponsiveImage;

